<template>
  <!-- <a-menu
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    :mode="mode"
    :theme="darkMode ? 'dark' : 'light'"
  >
    <a-menu-item @click="toggleCollapsed" key="dashboard">
      <router-link to="/">
        <sdFeatherIcons type="circle" />
        <span>
          Blank Page
        </span>
      </router-link>
    </a-menu-item>
  </a-menu> -->
  <router-link to="/">
              <img
                :src="
                  !darkMode
                    ? require(`../static/img/them_logo.png`)
                    : require(`../static/img/them_logo.png`)
                "
                alt="logo"
                style="margin-left: 40px; padding: 25px 0 25px 0 !important; width:65% !important;"
              />
    </router-link>
  <a-menu
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    :mode="mode"
    :theme="darkMode ? 'dark' : 'light'"
  >
  <a-menu-item key="dashboard">
      <router-link to="/">
        <sdFeatherIcons type="home" />
        <span> Dashboard </span>
      </router-link>
    </a-menu-item>
    <!--<a-menu-item key="adminmanagement" v-if="currentuser && currentuser.role_id === 6">
      <router-link to="/admin">
        <sdFeatherIcons type="airplay" />
        <span> Admin Panel </span>
      </router-link>
    </a-menu-item>-->
    <a-menu-item key="usermanagement">
      <router-link to="/users">
        <sdFeatherIcons type="users" />
        <span> User Management </span>
      </router-link>
    </a-menu-item>

    <a-menu-item key="rolemanagement">
      <router-link to="/roles">
        <sdFeatherIcons type="lock" />
        <span> Role Management </span>
      </router-link>
    </a-menu-item>
    
    
  </a-menu>
</template>
<script>
import {
  computed,
  reactive,
  ref,
  toRefs,
  watch,
  watchEffect,
  defineComponent,
} from "vue";
import VueTypes from "vue-types";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import versions from "../demoData/changelog.json";
export default defineComponent({
  name: "AsideItems",
  props: {
    toggleCollapsed: VueTypes.func,
    events: VueTypes.object,
    currentuser: VueTypes.object,
  },

  setup(props) {
    const store = useStore();
    const darkMode = computed(() => store.state.themeLayout.data);
    const mode = ref("inline");
    const { events } = toRefs(props);
    const routs = useRouter();
    const {
      onRtlChange,
      onLtrChange,
      modeChangeDark,
      modeChangeLight,
      modeChangeTopNav,
      modeChangeSideNav,
    } = events.value;
   const goBack = () => {
    routs.back();
    };
    const router = computed(() => useRoute());
    const state = reactive({
      selectedKeys: ["home"],
      openKeys: ["dashboard"],
      preOpenKeys: ["dashboard"],
    });

    watchEffect(() => { 
      if (router.value.matched.length) {
        if (router.value.matched.length > 2) {
          state.selectedKeys = [router.value.matched[2].name];
          state.openKeys = [router.value.matched[1].name];
          state.preOpenKeys = [router.value.matched[1].name];
        } else if (router.value.matched.length > 3) {
          state.selectedKeys = [router.value.matched[3].name];
          state.openKeys = [router.value.matched[1].name];
          state.preOpenKeys = [router.value.matched[1].name];
        } else {
          state.selectedKeys = [router.value.matched[1].name];
          state.openKeys = [router.value.matched[1].name];
          state.preOpenKeys = [router.value.matched[1].name];
        }
      }
    });

    watch(
      () => state.openKeys,
      (val, oldVal) => {
        state.preOpenKeys = oldVal;
      },

    );

    return {
      mode,
      ...toRefs(state),
      darkMode,
      onRtlChange,
      onLtrChange,
      modeChangeDark,
      modeChangeLight,
      modeChangeTopNav,
      modeChangeSideNav,
      versions,
      goBack,
    };
  },
});
</script>
